<button mat-icon-button class="menu-trigger" type="button" (click)="toggleDrawer()" [attr.aria-expanded]="isDrawerOpen" aria-controls="main-navigation" [attr.aria-label]="'menu.open' | translate">
  <img src="../../assets/icons/menu-hamb.png" alt="">
</button>

@if (isDrawerOpen) {
  <div class="menu-backdrop" (click)="closeDrawer()" aria-hidden="true"></div>
}

<aside id="main-navigation" class="menu-drawer" [class.menu-drawer--open]="isDrawerOpen" [attr.aria-hidden]="!isDrawerOpen">
  <div class="menu-drawer__header">
    <span>{{ 'menu.navigation' | translate }}</span>
    <button mat-icon-button type="button" (click)="closeDrawer()" [attr.aria-label]="'menu.close' | translate"><mat-icon>close</mat-icon></button>
  </div>

  <nav class="menu-drawer__content" [attr.aria-label]="'menu.navigation' | translate">
    @if (canSeeMenu('Preferencias')) {
      <button type="button" class="menu-link" [routerLink]="['/preferences']" (click)="closeDrawer()"><img src="../../assets/icons/preferencias.png" alt=""><span>{{ 'menu.preferences' | translate }}</span></button>
    }
    @if (canSeeMenu('Suscripciones')) {
      <button type="button" class="menu-link" [routerLink]="['/my-portals']" (click)="closeDrawer()"><img src="../../assets/icons/cuadra-white.png" alt=""><span>{{ 'menu.subscriptions' | translate }}</span></button>
    }
    @if (canSeeMenu('Clientes')) {
      <button type="button" class="menu-link" [routerLink]="['/reports']" (click)="closeDrawer()"><img src="../../assets/icons/grafico.png" alt=""><span>{{ 'menu.customers' | translate }}</span></button>
    }

    @if (canSeeReports()) {
      <section class="menu-group">
        <button type="button" class="menu-group__toggle" (click)="toggleReports()" [attr.aria-expanded]="isReportsOpen">
          <span>{{ 'menu.reports' | translate }}</span>
          <mat-icon [class.menu-group__chevron--open]="isReportsOpen">chevron_right</mat-icon>
        </button>
        @if (isReportsOpen) {
          <div class="menu-group__items">
            @if (canSeeMenu('Historial de Transacciones')) {
              <button type="button" class="menu-link menu-link--nested" [routerLink]="['/historic']" (click)="closeDrawer()"><img src="../../assets/icons/grafico.png" alt=""><span>{{ 'menu.transactionHistory' | translate }}</span></button>
            }
            @if (canSeeMenu('Cargos Aplicados')) {
              <button type="button" class="menu-link menu-link--nested" [routerLink]="['/applied-charges']" (click)="closeDrawer()"><img src="../../assets/icons/transactions.svg" alt=""><span>{{ 'menu.appliedCharges' | translate }}</span></button>
            }
            @if (canSeeServiceLaunchReport()) {
              <button type="button" class="menu-link menu-link--nested" [routerLink]="['/reports/service-launches']" (click)="closeDrawer()"><img src="../../assets/icons/reportes_aqua.png" alt=""><span>{{ 'menu.serviceLaunches' | translate }}</span><span class="menu-link__badge">{{ 'menu.new' | translate }}</span></button>
            }
            @if (canSeeRefundReport()) {
              <button type="button" class="menu-link menu-link--nested" [routerLink]="['/reports/refunds']" (click)="closeDrawer()"><img src="../../assets/icons/reportes_aqua.png" alt=""><span>{{ 'menu.refunds' | translate }}</span><span class="menu-link__badge">{{ 'menu.new' | translate }}</span></button>
            }
          </div>
        }
      </section>
    }

    @if (canSeeMenu('Carga de Archivos Para Cobro')) {
      <button type="button" class="menu-link" [routerLink]="['/batch-processing']" (click)="closeDrawer()"><img src="../../assets/icons/invoice.svg" alt=""><span>{{ 'menu.fileCharges' | translate }}</span></button>
    }
    @if (canSeeMenu('Reactivar cobros fallidos')) {
      <button type="button" class="menu-link" [routerLink]="['/failed-payments']" (click)="closeDrawer()"><img src="../../assets/icons/grafico.png" alt=""><span>{{ 'menu.failedPayments' | translate }}</span></button>
    }
    @if (canSeeMenu('Usuarios')) {
      <button type="button" class="menu-link" [routerLink]="['/onboarding-users-roles']" [queryParams]="{ tab: 'users' }" (click)="closeDrawer()"><img src="../../assets/icons/grafico.png" alt=""><span>{{ 'menu.users' | translate }}</span></button>
    }
    @if (canSeeMenu('Origenes permitidos')) {
      <button type="button" class="menu-link" [routerLink]="['/allowed-origins']" (click)="closeDrawer()"><img class="menu-link__inverted-icon" src="../../assets/icons/gps.svg" alt=""><span>{{ 'menu.allowedOrigins' | translate }}</span></button>
    }
    @if (canSeeMenu('Configuraciones')) {
      <button type="button" class="menu-link" [routerLink]="['/configurations']" (click)="closeDrawer()"><img src="../../assets/icons/grafico.png" alt=""><span>{{ 'menu.configurations' | translate }}</span></button>
    }
  </nav>

  <div class="menu-drawer__footer">
    <button type="button" class="menu-link" (click)="logout()"><img src="../../assets/icons/salida.png" alt=""><span>{{ 'menu.logout' | translate }}</span></button>
  </div>
</aside>
